import {
  Component,
  Inject,
  OnInit,
  ElementRef,
  ViewChild,
} from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

import { TranslateService } from "@ngx-translate/core";
import { KeyboardAlpha } from "../keyboard-alpha";
import * as _ from "lodash";

@Component({
  selector: "app-keyboard-alpha",
  templateUrl: "./keyboard-alpha.component.html",
  styleUrls: ["./keyboard-alpha.component.scss"],
  standalone: false,
})
export class KeyboardAlphaComponent implements OnInit {
  public keyboard: KeyboardAlpha = new KeyboardAlpha();
  public selectionStart: number = 0;
  public selectionEnd: number = 0;
  public elementValue: string;
  @ViewChild("keyValue") inputValue: ElementRef;

  constructor(
    private translateService: TranslateService,
    private dialogRef: MatDialogRef<KeyboardAlphaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  ngOnInit() {
    this.elementValue = _.cloneDeep(this.data.value);
    if (this.elementValue != null) {
      this.selectionStart = this.elementValue.length;
      this.selectionEnd = this.elementValue.length;
    }
    this.keyboard.setDefaultKeys();
    this.dialogRef.updateSize("80%", "80%");
    let textScreen: HTMLElement | null = document.getElementById("textScreen");
    if (textScreen == null) return;
    //Si al final es ús exclusiu del screeb keyboard el listener de keyup es pot eliminar
    textScreen.addEventListener("keyup", (e) => {
      if (
        e.target instanceof HTMLInputElement ||
        e.target instanceof HTMLTextAreaElement
      ) {
        this.selectionStart =
          e.target["selectionStart"] != null
            ? (e.target["selectionStart"] as number)
            : 0;
        this.selectionEnd =
          e.target["selectionEnd"] != null
            ? (e.target["selectionEnd"] as number)
            : 0;
      }
    });
    textScreen.addEventListener("click", (e) => {
      if (
        e.target instanceof HTMLInputElement ||
        e.target instanceof HTMLTextAreaElement
      ) {
        this.selectionStart =
          e.target["selectionStart"] != null
            ? (e.target["selectionStart"] as number)
            : 0;
        this.selectionEnd =
          e.target["selectionEnd"] != null
            ? (e.target["selectionEnd"] as number)
            : 0;
      }
    });
    textScreen.addEventListener("change", (e) => {
      if (
        e.target instanceof HTMLInputElement ||
        e.target instanceof HTMLTextAreaElement
      ) {
        this.selectionStart =
          e.target["selectionStart"] != null
            ? (e.target["selectionStart"] as number)
            : 0;
        this.selectionEnd =
          e.target["selectionEnd"] != null
            ? (e.target["selectionEnd"] as number)
            : 0;
      }
    });
  }

  triggerEvents() {
    this.data.dispatchEvent(new KeyboardEvent("input"));
    this.data.dispatchEvent(new KeyboardEvent("change"));
    this.data.dispatchEvent(new KeyboardEvent("keydown"));
  }

  triggerIntro() {
    var keyEvent = new KeyboardEvent("keydown", {
      bubbles: true,
      cancelable: true,
      key: "Enter",
      code: "Enter",
    });
    this.data.dispatchEvent(keyEvent);
  }

  getLength(start, end) {
    return end - start;
  }

  onShift() {
    this.keyboard.shift = !this.keyboard.shift;
    this.keyboard.mayus = false;
    if (this.keyboard.shift) {
      this.keyboard.setShiftKeys();
    } else {
      this.keyboard.setDefaultKeys();
    }
  }

  onMayus() {
    this.keyboard.mayus = !this.keyboard.mayus;
    this.keyboard.shift = false;
    if (this.keyboard.mayus) {
      this.keyboard.setShiftKeys();
    } else {
      this.keyboard.setDefaultKeys();
    }
  }

  addChar(char) {
    this.focus();
    let start = this.selectionStart;
    if (this.keyboard.shift) {
      this.keyboard.shift = false;
      this.keyboard.setDefaultKeys();
    }
    if (this.selectionEnd > start) {
      let splited = this.elementValue.split("");
      let length = this.getLength(start, this.selectionEnd);
      splited.splice(start, length, char);
      this.elementValue = splited.join("");
    } else {
      this.elementValue =
        this.elementValue.slice(0, start) +
        char +
        this.elementValue.slice(start);
    }
    this.selectionStart = start + 1;
    this.selectionEnd = start + 1;
  }

  backspace() {
    this.focus();
    let splited = this.elementValue.split("");
    let start = this.selectionStart;
    let screen = document.getElementById("textScreen");
    if (this.selectionEnd == this.selectionStart) {
      if (start > 0) {
        start -= 1;
      }
    }
    let length = this.getLength(start, this.selectionEnd);
    splited.splice(start, length);
    this.elementValue = splited.join("");
    this.selectionStart = start;
    this.selectionEnd = start;
  }

  onEnterClick(): void {
    this.data.value = this.elementValue;
    this.triggerEvents();
    this.triggerIntro();
    this.dialogRef.close(this.data);
  }

  focus() {
    this.inputValue.nativeElement.focus();
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
